<app-grit-dynamic-table
  (selectedRowEvent)="modelToFeature($event)"
  [tableConfiguration]="tableConfiguration"
  [entityName]="entityName"
  [type]="type" [mode]="mode" [pageSize]="pageSize"
  [models]="_models"
  [isAllSelected]="selectAll"
>
</app-grit-dynamic-table>

